module.exports = __webpack_public_path__ + "img/dash-01.774b8bc2.jpg";